
// cihan
import { useState } from "react";
import Columns from "../../../library/components/layout/Columns";
import Rows from "../../../library/components/layout/Rows";
import GenelDurumHelper from "../../../helpers/GenelDurumHelper";
import { Button, FormControl } from "@mui/material";
import { appIcons } from "../../../app/appIcons";
import StringHelper from "../../../library/helpers/StringHelper";
import VatanKadroSelectField from "../../../components/vatan/VatanKadroSelectField";
import { CsmText } from "../../../library/components/mui/CsmText";
import VatanSezonSelectField from "../../../components/vatan/VatanSezonSelectField";

interface IKazananKullaniciOlusturPopupEditorProps {
    genelDurumHelper: GenelDurumHelper,
    secilenSayi: number,
    closer: (model: string | null) => void,
}

function KazananKullaniciOlusturPopupEditor(props: IKazananKullaniciOlusturPopupEditorProps) {
    const { secilenSayi, closer, genelDurumHelper } = props;

    const secilebilirSezonlar = genelDurumHelper.SeciliKoroModel.tumSezonlar;


    const [seciliSezonId, setSeciliSezonId] = useState<string>(genelDurumHelper.SeciliKoroModel.sezonModelId);

    const secilebilirKadrolar = genelDurumHelper.SeciliKoroModel.tumKadrolar.where(e => e.sezonModelId === seciliSezonId);
    const [seciliKadroId, setSeciliKadroId] = useState<string>(StringHelper.nullToEmpty(secilebilirKadrolar.orderBy(e => e.olusturmaTarih).firstOrDefault()?.id));
    // others

    const onayla = async () => {
        closer(seciliKadroId);
    }

    return (
        <Rows gap={15}>
            <CsmText>Lütfen seçilen {secilenSayi?.toFixed()} aday koristin dahil edileceği kadroyu seçiniz</CsmText>
            <VatanSezonSelectField
                value={seciliSezonId}
                label="Seçili Sezon"
                tumSezonlar={secilebilirSezonlar}
                onChange={value => setSeciliSezonId(value)}
            />
            <FormControl style={{ display: "flex", flexDirection: "row" }}>
                <VatanKadroSelectField
                    value={secilebilirKadrolar.any(e => e.id === seciliKadroId) ? seciliKadroId : ""}
                    label="Aday Koristlerin Dahil Edileceği Kadro"
                    tumKadrolar={secilebilirKadrolar}
                    onChange={value => setSeciliKadroId(value)}
                />
            </FormControl>
            <Columns height={60} mt={10}>
                <Button color="error" variant="contained" onClick={() => closer(null)} style={{ flex: 1, margin: 10, marginLeft: 0 }}>
                    {appIcons.Popup.iptal}
                    {genelDurumHelper.translate("İptal")}</Button>
                <Button color="success" variant="contained" onClick={() => onayla()} style={{ flex: 1, margin: 10, marginRight: 0 }}>
                    {appIcons.Popup.tamam}
                    {genelDurumHelper.translate("Kaydet")}</Button>
            </Columns>
        </Rows >
    );

}

export default KazananKullaniciOlusturPopupEditor;